import { api } from '@creditsights/api-ui-web';
import {
  Consent,
  TranslationConsentContent,
  TranslationConsentUserAcknowledge,
  TranslationConsentUserAcknowledgeParams,
} from '../dtos/TranslationConsent.dto';

export const getTranslationConsentContent = async (): Promise<TranslationConsentContent> => {
  const { data } = await api.get<TranslationConsentContent>('common/v1/snippets/boilerplate/translation_legal');
  return data;
};

export const getTranslationConsentUserAcknowledge = async (
  userId: string
): Promise<TranslationConsentUserAcknowledge | null> => {
  const { data } = await api.get<TranslationConsentUserAcknowledge[]>(`profile/v1/profiles/${userId}/consents`);
  return data.find((item) => item.configuration.type === 'LanguageTranslation') ?? null;
};

export const saveTranslationConsentUserAcknowledge = async (
  userId: string,
  payload: TranslationConsentUserAcknowledgeParams
): Promise<void> => {
  return api.post(`profile/v1/profiles/${userId}/consents`, payload);
};

export type {
  Consent,
  TranslationConsentContent,
  TranslationConsentUserAcknowledge,
  TranslationConsentUserAcknowledgeParams,
};
